import React, { useEffect, useState } from "react";
import {
    useModalForm, Modal, Space, Form,
    Row,
    Col,
    Button,
    Input,
    Checkbox,
} from "@pankod/refine-antd";

export const ToggleConnectedBankingOptionsModel: React.FC<{ connectedBankingDetail: any, refetchConnectedBanking: any }> = ({ connectedBankingDetail, refetchConnectedBanking }) => {
    const { id, isQuickPayEnabled, isPreferredForQuickPayUpi, isPreferredForQuickPayBankTransfer } = connectedBankingDetail || {};
    const [quickPayUpiSupported, setQuickPayUpiSupported] = useState<boolean>(isQuickPayEnabled)
    const [preferredForQuickPayUpi, setPreferredForQuickPayUpi] = useState<boolean>(isPreferredForQuickPayUpi);
    const [preferredForQuickPayBankTransfer, setPreferredForQuickPayBankTransfer] = useState<boolean>(isPreferredForQuickPayBankTransfer);

    const { modalProps: bankOptionsModal, formProps: bankOptionsForm, show: bankOptionsShow, close: bankOptionsClose } = useModalForm<any>({
        action: "create",
        dataProviderName: "grapghQl",
        resource: "toggleConnectedBankingQuickPayPreferenceForBankAccount",
        metaData: {
            bankAccountId: id,
        },
        redirect: false,
        onMutationSuccess(response) {
            const result = response?.data;
            if (result?.success) {
                refetchConnectedBanking(true);
            } else {
                throw new Error(result?.message || 'Failed to save');
            }
        }
    });

    bankOptionsModal.title = `Edit Connected Banking Quick Pay Options`;
    bankOptionsModal.centered = true;
    bankOptionsModal.width = 800;
    bankOptionsModal.onCancel = () => {
        bankOptionsForm.form?.resetFields();
        setQuickPayUpiSupported(isQuickPayEnabled);
        setPreferredForQuickPayUpi(isPreferredForQuickPayUpi);
        setPreferredForQuickPayBankTransfer(isPreferredForQuickPayBankTransfer)
        bankOptionsClose();
    }

    const togglePreferenceCheckbox = (value: boolean, type: string): void => {
        switch (type) {
            case "upi":
                setPreferredForQuickPayUpi(value);
                bankOptionsForm.form?.setFieldsValue({ isPreferredForQuickPayUpi: value });
                break;
            case "bankTransfer":
                setPreferredForQuickPayBankTransfer(value);
                bankOptionsForm.form?.setFieldsValue({ isPreferredForQuickPayBankTransfer: value });
                break;
            case "isQuickPayEnabled":
                setQuickPayUpiSupported(value);
                bankOptionsForm.form?.setFieldsValue({ isQuickPayEnabled: value });
                break;
            default:
                return;
        }
    }

    useEffect(() => {
        if (bankOptionsModal.visible && connectedBankingDetail) {
            const {
                isQuickPayEnabled,
                isPreferredForQuickPayUpi,
                isPreferredForQuickPayBankTransfer
            } = connectedBankingDetail;

            togglePreferenceCheckbox(isQuickPayEnabled, 'isQuickPayEnabled');
            togglePreferenceCheckbox(isPreferredForQuickPayUpi, 'upi');
            togglePreferenceCheckbox(isPreferredForQuickPayBankTransfer, 'bankTransfer');
        }
    }, [bankOptionsModal.visible, connectedBankingDetail]);

    return (
        <Space>
            <Button className="credit-btn" type={'primary'} onClick={() => { bankOptionsShow() }}> Edit Bank Account Options</Button>

            <Modal {...bankOptionsModal}>
                <Form {...bankOptionsForm} initialValues={{ id }} layout="vertical">
                    <Row gutter={16}>
                        <Col lg={16}>
                            <Form.Item label="Id" name="id">
                                <Input disabled={true}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={16}>
                            <Form.Item label="Status" name="isQuickPayEnabled">
                                <Checkbox
                                    checked={quickPayUpiSupported}
                                    onChange={
                                        (e) => {
                                            togglePreferenceCheckbox(e.target.checked, 'isQuickPayEnabled');
                                        }
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col lg={8}>
                            <Form.Item label="UPI" name="isPreferredForQuickPayUpi">
                                <Checkbox
                                    disabled={!quickPayUpiSupported}
                                    checked={preferredForQuickPayUpi}
                                    onChange={
                                        (e) => {
                                            togglePreferenceCheckbox(e.target.checked, 'upi');
                                        }
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={8}>
                            <Form.Item label="Bank Transfer" name="isPreferredForQuickPayBankTransfer">
                                <Checkbox
                                    checked={preferredForQuickPayBankTransfer}
                                    onChange={
                                        (e) => {
                                            togglePreferenceCheckbox(e.target.checked, 'bankTransfer');

                                        }
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </Space>
    );
};